import { useState } from "react";
import { KeyRound, Loader2, Eye, EyeOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export function PasswordChangeGate({ children }) {
  const { user, setUser } = useAuth();
  const [f, setF] = useState({ current: "", next: "", repeat: "" });
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!user?.must_change_password || user.role === "admin") return children;
  const upd = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    if (f.next !== f.repeat) return toast.error("Le due nuove password non coincidono");
    setBusy(true);
    try {
      setUser((await api.post("/auth/change-password", { current_password: f.current, new_password: f.next })).data);
      toast.success("Password aggiornata");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  const type = show ? "text" : "password";
  return (
    <form onSubmit={submit} className="mx-auto max-w-sm space-y-3 py-4" data-testid="password-change-gate">
      <KeyRound className="h-7 w-7 text-[#61a229]" />
      <h1 className="font-display text-2xl font-bold">Scegli la tua password</h1>
      <p className="text-sm text-slate-500">È il tuo primo accesso: sostituisci la password ricevuta dall'ufficio con una personale (almeno 8 caratteri).</p>
      <Input type={type} placeholder="Password ricevuta" value={f.current} onChange={upd("current")} required data-testid="pwd-current" />
      <Input type={type} placeholder="Nuova password" value={f.next} onChange={upd("next")} minLength={8} required data-testid="pwd-new" />
      <Input type={type} placeholder="Ripeti nuova password" value={f.repeat} onChange={upd("repeat")} minLength={8} required data-testid="pwd-repeat" />
      <button type="button" onClick={() => setShow((s) => !s)} className="flex items-center gap-1 text-xs text-slate-500" data-testid="pwd-toggle">
        {show ? <EyeOff className="h-3.5 w-3.5" /> : <Eye className="h-3.5 w-3.5" />} {show ? "Nascondi" : "Mostra"} password
      </button>
      <Button type="submit" disabled={busy} className="w-full rounded-full bg-[#61a229] hover:bg-[#528a22]" data-testid="pwd-submit">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />} Salva e continua
      </Button>
    </form>
  );
}
